<template>
  <div>
        <v-container fluid>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
       <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

       <v-card class="box">
       <v-toolbar flat dense class="toolbar">
        <v-toolbar-title>Faculty Appraisal De-Mapping</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
      </v-toolbar>
       <v-row justify="center" dense>
        <v-col cols="12" sm="3" md="3">
            <p><v-icon color="error">*</v-icon><b>Authority Type</b></p>
            <v-autocomplete color="#0F2027" dense rounded required v-model="authority_type" :items="authority_type_list" item-text="name" item-value="id" label="Authority Type" outlined persistent-hint hint="Please Select Authority Type" />
        </v-col>
        <v-col cols="12" sm="3" md="3">
            <p><v-icon color="error">*</v-icon><b>Employee</b></p>
            <v-autocomplete color="#0F2027" dense rounded required v-model="instructor" :items="instructor_list" item-text="name" item-value="id" label="Employee" outlined persistent-hint hint="Please Select Employee" />
        </v-col>
            </v-row>
            <v-row justify="center" dense v-if="authority_type && instructor">
              <v-btn color="warning" @click="saveAppraisalAuthorityInstructor()">Save</v-btn>
        </v-row>
       </v-card>

     <v-card class="box" v-if="appraisal_authority_type_instructor_list != ''">
     <v-data-table  :headers="headers" :items="appraisal_authority_type_instructor_list" >
        <template v-slot:top>
            <v-toolbar flat class="toolbar">
                <v-toolbar-title>Faculty Appraisal De-Mapping List</v-toolbar-title>
                <v-divider class="mx-4" inset vertical ></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
        </template>
        <template v-slot:[`item.delete`]="{ item }">
            <v-avatar size="35">
              <v-icon
                class="mr-4 v-icon-size"
                color="red"
                @click="deleteLinking(item)"
                >mdi-trash-can</v-icon
              >
            </v-avatar>
          </template>
     </v-data-table>
 </v-card>
        </v-container>
  </div> <!-- /. root div -->
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    data: () => ({
      loader:false,
      snackbar_msg: "",
      color: "",
      snackbar: false,
      overlay: false,
      ay_list:[],ay:"",authority_type_list:[],authority_type:"",instructor_list:[],instructor:"",appraisal_authority_type_instructor_list:[],
      headers:[
      { text: "Sr no", value: "count" },
      { text: "Authority Type", value: "selfappriasalauthoritytype" },
      { text: "Employee", value: "instructor" },
      { text: "Delete", value: "delete" },
      ],
  }),
   methods: {
    deleteLinking(item){
      const data = {
        authority_type: item.selfappriasalauthoritytypeid,
        instructor: item.id,
      };
      this.overlay = true;
      this.loader = true;
      axios
        .post("/SelfAppriasalMaster/deleteLinking", data)
        .then((res) => {
          if (res.data.flag == "YES") {
           (this.appraisal_authority_type_instructor_list = res.data.appraisal_authority_type_instructor_list)
            this.showSnackbar("green", "Details Deleted Successfully...");
          } else if (res.data.flag == "No") {
            this.showSnackbar("red", res.data.snackbar);
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          //this.onerror(error);
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          this.loader = false;
        });
    },
    saveAppraisalAuthorityInstructor(){
      const data = {
        ay: this.ay,
        authority_type: this.authority_type,
        instructor: this.instructor,
      };
      this.overlay = true;
      this.loader = true;
      axios
        .post("/SelfAppriasalMaster/saveAppraisalAuthorityInstructorMapping", data)
        .then((res) => {
          if (res.data.flag == "YES") {
           (this.appraisal_authority_type_instructor_list = res.data.appraisal_authority_type_instructor_list)
            this.showSnackbar("green", "Saved Successfully...");
          } else if (res.data.flag == "No") {
            this.showSnackbar("red", res.data.snackbar);
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          //this.onerror(error);
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          this.loader = false;
        });
    },
      onLoad() {
        axios
            .post("SelfAppriasalMaster/instructorAppraisalAuthorityTypeMapping")
            .then((res) => {
                if (res.data.flag == "YES") {
                    // (this.ay_list = res.data.ay_list),
                    (this.appraisal_authority_type_instructor_list = res.data.appraisal_authority_type_instructor_list),
                    (this.authority_type_list = res.data.authority_type_list),
                    (this.instructor_list = res.data.instructor_list),
                   //  (this.ay = res.data.current_ay);
                    this.overlay = false;
                } else {
                    this.showSnackbar("#b71c1c", res.data.status_reason);
                }
            })
            .catch((error) => {
                this.showSnackbar("#b71c1c", "Something went wrong!!!");
                this.overlay = false;
            })
            .finally(() => {
                this.overlay = false;
            });
            },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
   mounted() {
   this.onLoad();
  },
  watch: {},
};
</script>
<style scoped>
</style>